import { render, staticRenderFns } from "./CatalogPageElement.vue?vue&type=template&id=7c7b7150&scoped=true"
import script from "./CatalogPageElement.vue?vue&type=script&lang=js"
export * from "./CatalogPageElement.vue?vue&type=script&lang=js"
import style0 from "./CatalogPageElement.vue?vue&type=style&index=0&id=7c7b7150&prod&lang=scss&scoped=true"
import style1 from "./CatalogPageElement.vue?vue&type=style&index=1&id=7c7b7150&prod&scoped=true&lang=css"
import style2 from "./CatalogPageElement.vue?vue&type=style&index=2&id=7c7b7150&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7b7150",
  null
  
)

export default component.exports